import GOProfile from './GOProfile'
import MyGenerators from './pages/MyGenerators/MyGenerators'
import GOPaymentOperations from './pages/GOPaymentOperations/GOPaymentOperations'
import GOPersonalOperations from './pages/GOPersonalOperations/GOPersonalOperations'

export { GOProfile, MyGenerators, GOPaymentOperations, GOPersonalOperations }
